<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center mt-5">
        <b-col xl="4" lg="6">
          <b-card>
            <div slot="header">Depreciation Process of Fixed Assets 
            </div>
            <b-input-group class="p-2">
                <b-input-group-prepend><span class="p-2">Accounting Periode </span></b-input-group-prepend>
                <vue-monthly-picker v-model="filter.periode" dateFormat="MMMM YYYY" :monthLabels="monthLabels" @selected="onChangeMonth" style="width: 360px !important;"></vue-monthly-picker>
            </b-input-group>

            <b-row class="justify-content-center mt-2">
                <button  class="btn btn-primary ml-5 mr-1"  @click="process()" > <i class="fa fa-play"></i> Process Depreciation</button>
                <b-button class="btn btn-success mr-2" @click="printjv()" > <i class="fa fa-table"></i> View Depreciation</b-button>
                <b-button class="btn btn-danger" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
            </b-row>

          </b-card>    
            </b-col>
        </b-row>

      <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
      <b-modal v-model="showReport" size="xl" scrollable  title="Preview as PDF" ok-only>
          <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
      </b-modal>
  </div>
</template>

<style lang="scss">
    .list-of-fixedasset {
      table {
        td:nth-child(1) {
          width: auto;
        }
        td:nth-child(2) {
          width: 120px;
        }
      }
    }
 
</style>


<script>
import toastr from "mini-toastr";
import moment from 'moment';
import VueMonthlyPicker from 'vue-monthly-picker';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import fa_depreciate from "../../apis/fa_depreciate";
import dropdown from "../../data/dropdown";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
        tgldepr1: { required },
        tgldepr2: { required },
    },
  }, 
  components: { VueMonthlyPicker,Loading},
  data() {
    return {
      isLoading:false,
      showReport:false,
      reportUrl: null,
      horizontal: true,
      showList:true,
      showForm:false,
      showFilter:false,
      filter: { periode:'',
        tgl1:this.$store.state.user.tglaktif,
        tgl2:this.$store.state.user.akhirbln, 
      },
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        tgl1:this.$store.state.user.tglaktif,
        tgl2:this.$store.state.user.akhirbln,
        sortBy: null,
        sortDesc: false, catgid:'',DimCol:''
      },
      tblLcy: {
        page: 1,
        limit: 100,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields:[
          {
            key: "catgname",
            label: "Category/Group Name",
            sortable: true
          },
          {
            key: "akum_acc",
            label: "Depreciation Accumu. Account",
            sortable: true
          },
          {
            key: "biaya_acc",
            label: "Depreciation Expense Account",
            sortable: true
          },
          {
            key: "depamount",
            label: "Depreciation Amount",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
          },

        ]
      },

      terpilih:{asetkey:''},
      YesNoAll: dropdown.YesNoAll,
      monthLabels:dropdown.monthLabels,
      categories:[]
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
          {
            key: "asetid",
            thStyle: "width:100px",
            label: "FA Number",
            sortable: true
          },
          {
            key: "asdesc",
            label: "Description",
          },
          {
            key: "asmodel",
            label: "Model/Type/Series",
          },
          {
            key: "masa",
            thStyle: "width:80px",
            label: "Depreciation Period",
          },
          {
            key: "tgl_gl",
            thStyle: "width:80px",
            label: "Depreciation Date",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "nomorgl",
            thStyle: "width:180px",
            label: "Depreciation JV Number",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "depamount",
            label: "Depreciation Amount",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "depaccum",
            label: "Accumulate Depreciated",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "catgname",
            label: "Category/Group",
            thStyle: "width:200px",
            sortable: true
          },
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: dims[i].value,
            // thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }
      return fields;
    },
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
    catgid() {
      return this.tblData.catgid;
    },
    dimCol() {
        return this.tblData.DimCol;
    }    
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
    catgid: function(newval){
      console.log('category Id : ', newval);
      const catg = this.categories.find(c => c.value == newval)
      if (catg)
      {
        this.tblData.category=catg.text;
        console.log('category : ', catg.text);
      }
    }
  },
  created: async function(){
        this.filter.periode = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        this.filter.tgldepr1=this.$store.state.user.tglaktif;
        this.filter.tgldepr2= this.filter.periode.format('YYYY-MM-DD');
        this.tblData.tgldepr1=this.filter.tgldepr1;
        this.tblData.tgldepr2= this.filter.tgldepr2;
  },  
  methods: {
    onChangeMonth: async function (){
        var tgl=this.filter.periode;
        this.filter.tgldepr1=tgl.startOf('month').format('YYYY-MM-DD');
        this.filter.tgldepr2=tgl.endOf('month').format('YYYY-MM-DD');
        console.log('this.filter : ',this.filter);
        this.$forceUpdate();
    },  
    process: async function() {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {            
         try {
              this.isLoading=true;
              let data= {}
              data.tglakan = moment(this.filter.tgldepr2).format('YYYY-MM-DD');
              await fa_depreciate.process(data);
              toastr.success("Complete successfully", "Depreciation Process");
              this.isLoading=false;      
            } catch (error) {
              this.isLoading=false;      
                console.log('error : ', error);
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }        
            }
       }
    },
    printjv: async function() {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {            
         try {
              let data= {}
              data.tglakan = moment(this.filter.tgldepr2).format('YYYY-MM-DD');
              this.showReport=true;
              toastr.info('Loading Depreciation Journal Voucher','View Depreciation',10000);
              this.reportUrl= await fa_depreciate.printjv(data);

            } catch (error) {
              this.isLoading=false;      
                console.log('error : ', error);
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }        
            }
       }
    },
   

    close(){
      router.push("home");
    },    
  }
};
</script>
